import { render, staticRenderFns } from "./SimpleSelectForm.vue?vue&type=template&id=150d79a6&lang=pug&"
import script from "./SimpleSelectForm.vue?vue&type=script&lang=js&"
export * from "./SimpleSelectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports